<template>
    <div class="admin">
        <el-container class="admin-container">
            <el-aside width="200px" class="admin-aside">
                <el-menu default-active="2" class="el-menu-vertical-demo" router>
                    <el-menu-item index="/admin/user">
                        <i class="el-icon-star-off"></i>
                        <span slot="title">后台用户管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/news">
                        <i class="el-icon-news"></i>
                        <span slot="title">新闻咨询管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/cpzx">
                        <i class="el-icon-news"></i>
                        <span slot="title">产品中心</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/jjfa">
                        <i class="el-icon-news"></i>
                        <span slot="title">解决方案</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/cases">
                        <i class="el-icon-location-outline"></i>
                        <span slot="title">案例信息管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/team">
                        <i class="el-icon-picture-outline"></i>
                        <span slot="title">团队风采管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/course">
                        <i class="el-icon-time"></i>
                        <span slot="title">发展历程管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/enterprise">
                        <i class="el-icon-edit-outline"></i>
                        <span slot="title">合作企业管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/honor">
                        <i class="el-icon-edit-outline"></i>
                        <span slot="title">荣誉墙管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/xzzx">
                        <i class="el-icon-news"></i>
                        <span slot="title">下载中心</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/dictionary">
                        <i class="el-icon-setting"></i>
                        <span slot="title">数据字典管理</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/page">
                        <i class="el-icon-setting"></i>
                        <span slot="title">测试分页</span>
                    </el-menu-item>
                </el-menu>
            </el-aside>
            <el-container class="admin-main-container">
                <el-main class="admin-main">
                    <div class="base-padding">
                        <router-view/>
                    </div>
                </el-main>
                <el-footer>2019@广东通创联新技术有限公司版权所有</el-footer>
            </el-container>
        </el-container>
    </div>
</template>

<script>
export default {
    name: "admin"
};
</script>

<style lang="scss" scoped>
.admin {
    border-top: 1px solid rgb(238, 238, 238);
    height: calc(100vh - 60px);
    overflow: hidden;
}

.admin-container {
    height: 100%;
}

.admin-aside {
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    border-right: 1px solid #e6e6e6;
}

.admin-main-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.admin-main {
    flex: 1;
    overflow-y: auto;
    padding: 0;
}

.base-padding {
    padding: 20px;
}

.el-footer {
    line-height: 60px;
    flex-shrink: 0;
}
</style>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
